import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";
import type { ProductType } from "@zhihaoscm/entity";

class ProductTypeService extends BaseService<ProductType, ProductType, { keyword?: string }, unknown> {
    public override async selector(params?: { keyword?: string }) {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }
}

export const productTypeService = new ProductTypeService("/product-type", httpRequest);
